class UserSocialAccounts {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/social-accounts`;

  }

  getAccounts() {

    return this.apiClient.get(this.basePath, {}, {});

  }

}

export default UserSocialAccounts;
